import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Which tool's sections are shown inside the User Guide. */
export type GuideTool = 'usdm' | 'sdtm';

/**
 * User Guide content for Clinical AI Studio.
 *
 * Projected into the shared shell by {@link Docs2Component} when the User Guide
 * card is selected. It always shows "Choose a tool"; picking a tool card emits
 * {@link toolSelected} and, once {@link tool} is set, only that tool's sections
 * render. Section ids match `GUIDE_USDM_GROUPS` / `GUIDE_SDTM_GROUPS`
 * (see docs-groups.ts). Content-only — no sidebar of its own.
 */
@Component({
  selector: 'app-docs-guide',
  standalone: true,
  imports: [],
  templateUrl: './docs-guide.component.html',
  styleUrl: './docs-guide.component.css',
})
export class DocsGuideComponent {
  /** The chosen tool, or null while the reader is still on "Choose a tool". */
  @Input() tool: GuideTool | null = null;

  /** Emitted when a tool card is clicked; the hub owns the resulting state. */
  @Output() readonly toolSelected = new EventEmitter<GuideTool>();
}
